var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingUpload
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingUpload = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1 col-md-12",
    staticStyle: {
      "margin-bottom": "0rem",
      "padding": "0px",
      "background-color": "white"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button', {
        active: _vm.currentTab === tab.key
      }],
      style: (("" + ((_vm.tabs.length==1) ? 'width: 100%;' : ''))),
      attrs: {
        "id": tab.value
      },
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key;
          _vm.secondFunction(tab);
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.value) + "\n          ")])
  }), 0), _vm._v(" "), _c('fieldset', [(_vm.currentTab == 'upload') ? _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onUploadSubmit.apply(null, arguments)
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Dock Config ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('configFile')
    },
    attrs: {
      "type": "file",
      "placeholder": "Upload File",
      "name": "configFile",
      "id": "configFile"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * Only .csv OR .zip files allowed to upload.")])], 1), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('configFile')),
      expression: "errors.has('configFile')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Upload file is required.")])], 1), _vm._v(" "), (_vm.failed.length > 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Download Failed Config")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Failed Dock Config",
      "target": "_blank"
    },
    on: {
      "click": _vm.exportFailedConfig
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    }
  }, [_vm._v("Download\n                          "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px",
      "color": "red"
    }
  })])])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "submit",
      "title": "Upload Sorter Config File For Selected Sorter Hub"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "margin-top": "15px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "text-primary"
  }, [_vm._v("Active File Data")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('basic-select', {
    class: {
      'form-control': true, 'error': _vm.errors.has('filterOperation')
    },
    attrs: {
      "options": _vm.operationOptions,
      "selected-option": _vm.filterOperation,
      "name": "filterOperation",
      "placeholder": "Select  status"
    },
    on: {
      "select": _vm.selectedStatus
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Dock ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDockId),
      expression: "filterDockId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Dock ID"
    },
    domProps: {
      "value": (_vm.filterDockId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDockId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.applyFilters
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetFilters
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")]), _vm._v(" "), (_vm.dockFileData.length > 0) ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoadingSearch,
      "title": "Download active dock config for this hub"
    },
    on: {
      "click": _vm.downloadActiveConfig
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download\n              ")]) : _c('button', {
    staticClass: "btn btn-info",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button",
      "title": "Download a sample CSV to see the required layout"
    },
    on: {
      "click": _vm.downloadSampleCsv
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Sample CSV\n              ")])])]), _vm._v(" "), _c('div', {
    style: (_vm.dockFileData.length > 8 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Dock ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Dock Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Dock Barcode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Dock Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Max Vehicles")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vehicle Capacity")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Dock Height")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Weighing Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Preferred BU")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Camera Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Is Active")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.dockFileData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s((_vm.pageno * _vm.limit) + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.dock_id))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.dock_number))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.dock_barcode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.dock_type))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.max_vehicles))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vehicle_capacity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.dock_height))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.weighing_type))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.preferred_bu))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.camera_name))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.is_active ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hub_id))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      on: {
        "click": function($event) {
          return _vm.openEditDockRow(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])])
  }), _vm._v(" "), (_vm.dockFileData.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "15"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 10),
      expression: "totalRows>10"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.isEditingDock) ? _c('b-card', [_c('h6', {
    staticClass: "text-primary"
  }, [_vm._v("Edit Dock Row — " + _vm._s(_vm.editDockForm.dock_id))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitEditDockRow.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Dock Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDockForm.dock_type),
      expression: "editDockForm.dock_type"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "dock_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editDockForm, "dock_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Dock Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Running"
    }
  }, [_vm._v("Running")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Standalone"
    }
  }, [_vm._v("Standalone")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Max Vehicles")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDockForm.max_vehicles),
      expression: "editDockForm.max_vehicles"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.editDockErrors.max_vehicles
    },
    attrs: {
      "type": "number",
      "min": "1",
      "step": "1",
      "name": "max_vehicles"
    },
    domProps: {
      "value": (_vm.editDockForm.max_vehicles)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editDockForm, "max_vehicles", $event.target.value)
      }, _vm.validateMaxVehicles],
      "blur": _vm.validateMaxVehicles
    }
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editDockErrors.max_vehicles),
      expression: "editDockErrors.max_vehicles"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.editDockErrors.max_vehicles) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Vehicle Capacity")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDockForm.vehicle_capacity),
      expression: "editDockForm.vehicle_capacity"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.editDockErrors.vehicle_capacity
    },
    attrs: {
      "type": "number",
      "min": "1",
      "step": "any",
      "name": "vehicle_capacity"
    },
    domProps: {
      "value": (_vm.editDockForm.vehicle_capacity)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editDockForm, "vehicle_capacity", $event.target.value)
      }, _vm.validateVehicleCapacity],
      "blur": _vm.validateVehicleCapacity
    }
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editDockErrors.vehicle_capacity),
      expression: "editDockErrors.vehicle_capacity"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.editDockErrors.vehicle_capacity) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Dock Height")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDockForm.dock_height),
      expression: "editDockForm.dock_height"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.editDockErrors.dock_height
    },
    attrs: {
      "type": "number",
      "min": "1",
      "step": "any",
      "name": "dock_height"
    },
    domProps: {
      "value": (_vm.editDockForm.dock_height)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editDockForm, "dock_height", $event.target.value)
      }, _vm.validateDockHeight],
      "blur": _vm.validateDockHeight
    }
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editDockErrors.dock_height),
      expression: "editDockErrors.dock_height"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.editDockErrors.dock_height) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Weighing Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDockForm.weighing_type),
      expression: "editDockForm.weighing_type"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "weighing_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editDockForm, "weighing_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Weighing Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DWS"
    }
  }, [_vm._v("DWS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Manual"
    }
  }, [_vm._v("Manual")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TBC"
    }
  }, [_vm._v("TBC")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Preferred BU")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDockForm.preferred_bu),
      expression: "editDockForm.preferred_bu"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "preferred_bu"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editDockForm, "preferred_bu", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Preferred BU")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B2B"
    }
  }, [_vm._v("B2B")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B2C"
    }
  }, [_vm._v("B2C")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B2B- LH"
    }
  }, [_vm._v("B2B- LH")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B2B and B2C LH"
    }
  }, [_vm._v("B2B and B2C LH")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LH"
    }
  }, [_vm._v("LH")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Status")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDockForm.status),
      expression: "editDockForm.status"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('status')
    },
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editDockForm, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Operational"
    }
  }, [_vm._v("Operational")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Non-Operational"
    }
  }, [_vm._v("Non-Operational")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Under Maintenance"
    }
  }, [_vm._v("Under Maintenance")])]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('status')),
      expression: "errors.has('status')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                    Status is required.\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Camera Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDockForm.camera_name),
      expression: "editDockForm.camera_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.editDockForm.camera_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editDockForm, "camera_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEditDockRow
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'history') ? _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    style: (_vm.fileDetails.length > 12 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("File Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("File Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Uploaded By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Uploaded Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("View")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.fileDetails), function(data, index) {
    return (_vm.fileDetails.length > 0) ? _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.filename))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.filetype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.uploaded_by))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment1")(data.uploaded_at)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s((data.is_active == true) ? 'Active' : 'Inactive'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index < 6),
        expression: "index < 6"
      }],
      staticStyle: {
        "font-size": "initial",
        "cursor": "pointer",
        "margin-left": "1%"
      },
      on: {
        "click": function($event) {
          return _vm.selectFile(data)
        }
      }
    }, [_c('i', {
      class: data.is_active ? 'fa fa-toggle-on' : 'fa fa-toggle-off',
      style: ({
        color: data.is_active ? 'green' : 'red'
      }),
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  \n                      ")]), _vm._v(" "), (!data.is_active) ? _c('span', [_vm._v("        ")]) : _vm._e(), _vm._v(" "), (!data.is_active) ? _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index < 6),
        expression: "index<6"
      }],
      staticStyle: {
        "color": "rgb(208,101,22)",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Download config file"
      },
      on: {
        "click": function($event) {
          return _vm.downloadConfigfromDB(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.getDockConfigLogs(data)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.fileDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])], 1) : _vm._e()], 1)], 1)])]), _vm._v(" "), (_vm.currentTab == 'print') ? _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Print Barcode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.barcodeList,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "placeholder": "Select Barcodes",
      "label": "dock_barcode",
      "track-by": "dock_id",
      "name": "printbarcode"
    },
    on: {
      "input": function($event) {
        return _vm.selectBarcodePrint(_vm.printbarcode)
      }
    },
    model: {
      value: (_vm.printbarcode),
      callback: function($$v) {
        _vm.printbarcode = $$v
      },
      expression: "printbarcode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.printbarcode.length === 0
    },
    on: {
      "click": _vm.printSelectedBarcode
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print Selected\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.barcodeList.length === 0
    },
    on: {
      "click": _vm.printAllBarcode
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print All Barcode\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetPrintForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset\n                ")])])])], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "activationConfirmationModal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.addmodalShow),
      callback: function($$v) {
        _vm.addmodalShow = $$v
      },
      expression: "addmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.modalPromptText))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.takeAction, function($event) {
        _vm.addmodalShow = false
      }]
    }
  }, [_vm._v(_vm._s(_vm.modalActionText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), (_vm.showModal == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Config File Logs"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Config File Logs")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "300px",
      "margin-top": "00px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("File Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("User")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Remarks")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.configFileLogs), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.file_id) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.action))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.modified_by))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.modified_date)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.remarks))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")])])])])]) : _vm._e()], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-bottom": "0.5%",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticStyle: {
      "border": "0px"
    }
  }, [_vm._v("Dock Master")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dacde6","hasScoped":true}!./src/views/components/DockMaster/DockMaster.html
// module id = 2060
// module chunks = 2